import { useTranslation } from 'react-i18next';
import { useRoute } from '../sitecoreContext';
import { getPageTitle } from '../sitecoreFields';
const usePageTilte = (modelName, isInventory) => {
    const { t } = useTranslation();
    const route = useRoute();
    const pageTitle = getPageTitle(route);
    const pageTitleTag = isInventory ? t(pageTitle, { modelName }) : pageTitle;
    return pageTitleTag;
};
export default usePageTilte;
